import { Component, OnInit,  NgZone } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import {CommonService} from './../../services/common.service';
import {ActivatedRoute, Router, Params,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import * as jQuery from 'jquery';
import { ProductsService } from '../../services/products.service';


@Component({
  selector: 'app-productmenu',
  templateUrl: './productmenu.component.html',
  styleUrls: ['./productmenu.component.css']
})
export class ProductmenuComponent implements OnInit {
  x: HTMLElement;
  searchdata: any;
  searchterm: any;
  timer: any;
  counter = 3;

  constructor(private commonService: CommonService, private router: Router,
  public productService: ProductsService, public zone: NgZone) {
  if (document.getElementById('js1')) {
      document.getElementById('js1').remove();
      const js1 = document.createElement('script');
      js1.setAttribute('id', 'js1');
      js1.setAttribute('src', './assets/js/jquery-3.2.1.min.js');
      document.body.appendChild(js1);
    }
    if (document.getElementById('js2')) {
    document.getElementById('js2').remove();
    const js2 = document.createElement('script');
    js2.setAttribute('id', 'js2');
    js2.setAttribute('src', './assets/js/webslidemenu.js');
    document.body.appendChild(js2);
    }
    this.productService.productroutechange.subscribe((x) => {
      if (x == 1) {
        this.togglenav2();
        this.counter = 3;
        this.timer = setInterval(() => this.timedelay(), 1000);
      }
    });
  }

  ngOnInit() {
    this.getSearchdata();
    var headerfull = document.getElementById("wmsticky");
        var sticylogo = document.getElementById("sticylogo2");

        var sticky = headerfull.offsetTop;

        window.onscroll = function() {myFunction()};

      function myFunction() {
      if (window.pageYOffset >= sticky) {
        headerfull.classList.add("sticky");
        sticylogo.classList.add("sticky2");
      } else {
        headerfull.classList.remove("sticky");
        sticylogo.classList.remove("sticky2");
      }
      }

  }
  getSearchdata() {
    this.commonService.getProductSearchdata()
    .subscribe (
      (x) => {
        this.searchdata = x;
      });
  }
togglenav() {
      var x = document.getElementById("hidenav");
      var y = document.getElementById("hidenav2");
      if (x.style.display === 'none') {
          x.style.display = 'block';
      }
      if (y.style.display === 'none') {
          y.style.display = 'block';
      }
    }
  togglenav2() {
    var x = document.getElementById("hidenav");
    var y = document.getElementById("hidenav2");
       x.style.display = 'none';
       y.style.display = 'none';
  }



  timedelay() {
    this.counter = this.counter - 1;
    if (this.counter == 0) {
      clearInterval(this.timer);
      this.togglenav();
      this.productService.productroute.next(0);
    }
  }
  checkEveryMatch(str, element) {
    if ( str.toString().toLowerCase().match(element)) {
      return 1;
    }else {
      return 0;
    }
  }
  search = (text$: Observable<string>) =>
  text$
    .debounceTime(200)
    .map((term) => {
      var stringarr = this.searchterm.toString().toLowerCase().split(' ');
      var stringlen = stringarr.length;
      var out = [];
      for (let d in this.searchdata) {
        var rescount = 0;
            for (let i in stringarr) {
              var res = this.checkEveryMatch(this.searchdata[d].title, stringarr[i])
              var rescount = rescount + res;
            }
            if (rescount === stringlen) {
              out.push(this.searchdata[d]);
            }
      }
      return out;
    });
     formatter = (x: {title: string}) => x.title;
 goToDetail(id, url, type) {
      if (type === 'product') {
        this.router.navigate(['/store/details/', id , url]);
      }
    }
    goToSearch() {
        const a = typeof this.searchterm;
        if (a === 'object') {
          this.router.navigate(['/store/details/', this.searchterm.id , this.searchterm.url]);
        }else if (this.searchterm == undefined) {
            alert('nothing to search');
          } else if (this.searchterm == '') {
            alert('nothing to search');
          } else {
              this.router.navigate(['/store/search/', 'product', this.searchterm]);
        }
    }

    selectedItem(item) {
      if (item.code === 'Enter') {
        this.goToSearch()
      }
    }



}
